import Page from 'lemon-campaign-ui/lib/atoms/Page'
import PageTransition from 'gatsby-v2-plugin-page-transitions'
import React from 'react'
import Mapper from './mapper'

const PageContent = ({ page, mapperProps, footer, showBadge, children }) => {
  return (
    <Page id={page._id} key={page._id}>
      {children}

      <PageTransition>
        <React.Fragment>
          <main>
            {page.components.map((component) => {
              return <Mapper {...mapperProps} key={component._id} component={component} />
            })}
          </main>

          <Mapper {...mapperProps} key={footer._id} component={footer} />
        </React.Fragment>
      </PageTransition>
    </Page>
  )
}

export default PageContent
